class Breakpoints {
  constructor(updateCallback = () => {}) {
    this.updateCallback = updateCallback;
    this.defaultValue = 0;
    this.eventoInicializado = false;

    this.xl = false;
    this.lg = false;
    this.md = false;
    this.sm = false;
    this.xs = false;
    this.fhd = false;
    this.width = 0;
    this.height = 0;

    this.breakLimit = {
      xs: 575,
      sm: 767,
      md: 991,
      lg: 1199,
      xl: 1919,
      fhd: 1920,
    };

    this.timeoutAtualizacao = 0;

    this.atualizeBreaks(null, true);
    this.inicieEventos();
  }

  get values() {
    return {
      fhdOnly: this.fhd,

      xlOnly: this.xl,
      xlAndDown: (this.xs || this.sm || this.md || this.lg || this.xl) && !this.fhd,
      xlAndUp: !(this.xs || this.sm || this.md || this.lg) && (this.xl || this.fhd),

      lgOnly: this.lg,
      lgAndDown: (this.xs || this.sm || this.md || this.lg) && !(this.xl || this.fhd),
      lgAndUp: !(this.xs || this.sm || this.md) && (this.lg || this.xl || this.fhd),

      mdOnly: this.md,
      mdAndDown: (this.xs || this.sm || this.md) && !(this.lg || this.xl || this.fhd),
      mdAndUp: !(this.xs || this.sm) && (this.md || this.lg || this.xl || this.fhd),

      smOnly: this.sm,
      smAndDown: (this.xs || this.sm) && !(this.md || this.lg || this.xl || this.fhd),
      smAndUp: !this.xs && (this.sm || this.md || this.lg || this.xl || this.fhd),

      xsOnly: this.xs,

      width: this.width,
      height: this.height,
    };
  }

  get clientWidth() {
    return document.documentElement.clientWidth || this.defaultValue;
  }

  get clientHeight() {
    return document.documentElement.clientHeight || this.defaultValue;
  }

  inicieEventos() {
    if (window) {
      this.eventoInicializado = true;
      window.addEventListener('resize', this.atualizeBreaks.bind(this), { passive: true });
    }
  }

  /* istanbul ignore next */
  atualizeBreaks(event, ignoreTimeout = false) {
    clearTimeout(this.timeoutAtualizacao);

    // 50 ms de intervalo para evitar perda de performance ou callbacks desnecessários
    /* istanbul ignore next */
    this.timeoutAtualizacao = setTimeout(
      () => {
        this.calculeValores();

        if (this.updateCallback && typeof this.updateCallback === 'function') {
          this.updateCallback.call(this, this.values);
        }
      },
      ignoreTimeout ? 0 : 50,
    );
  }

  calculeValores() {
    this.width = this.clientWidth;
    this.height = this.clientHeight;

    this.xs = this.width <= this.breakLimit.xs;
    this.sm = this.width <= this.breakLimit.sm && !this.xs;
    this.md = this.width <= this.breakLimit.md && !(this.sm || this.xs);
    this.lg = this.width <= this.breakLimit.lg && !(this.md || this.sm || this.xs);
    this.xl = this.width <= this.breakLimit.xl && !(this.md || this.sm || this.xs || this.lg);
    this.fhd = this.width >= this.breakLimit.fhd;
  }
}

export default Breakpoints;
